<template>
	<nav>
		<ul>
			<slot />
		</ul>
	</nav>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
nav {
	display: flex;
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;

	box-sizing: border-box;
	height: 86px;
	padding: 1rem;
	padding-top: 0.5rem;
	padding-bottom: 2rem;

	background-color: var(--background-25);
	border-top: 1px solid var(--background-200);

	z-index: 100;
}

ul {
	display: flex;
	justify-content: space-around;
	align-items: center;
	height: 100%;
	flex: 1;
}

:deep() li {
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 44px;
	height: 44px;
	border-radius: 50%;
	transition: background-color 0.35s cubic-bezier(0.075, 0.82, 0.165, 1);

	span {
		top: 38px;
		transition: top 0.35s cubic-bezier(0.075, 0.82, 0.165, 1);
	}

	&:hover {
		background-color: var(--background-100);
		svg {
			color: var(--text-300);
			opacity: 1;
		}

		span {
			color: var(--text-300);
			top: 46px;
		}
	}

	&.active {
		background-color: var(--ls-primary-legible-color);
		svg {
			color: var(--black-50);
			opacity: 0.8;
		}

		span {
			top: 48px;
		}
	}

	a {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
	}

	svg {
		color: var(--text-50);
		opacity: 0.5;
		transition: opacity 0.35s cubic-bezier(0.075, 0.82, 0.165, 1);
		width: 26px;
		height: 26px;
	}

	span {
		position: absolute;
		transition: top 0.35s cubic-bezier(0.075, 0.82, 0.165, 1);
		text-wrap: none;
		white-space: nowrap;
		color: var(--text-500);
		font-size: 0.85rem;
	}
}
:deep() li.primary {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: var(--background-400);
	box-shadow: 0px 3px 8px 0px rgba(0, 0, 0, 0.25);

	a {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
		background-color: transparent;
		border: none;
		cursor: pointer;
	}

	svg {
		opacity: 1;
		color: var(--black-50);
	}

	&.active {
		background-color: var(--ls-primary-legible-color);
	}

	&:hover {
		background-color: var(--ls-primary-legible-hover-color);
	}
}

@media (prefers-color-scheme: dark) {
	nav {
		:deep() li.primary {
			background-color: var(--background-300);
		}
	}
}
:root[data-theme="dark"] {
	nav {
		:deep() li.primary {
			background-color: var(--background-300);

			&.active {
				background-color: var(--ls-primary-legible-color);
			}

			&:hover {
				background-color: var(--ls-primary-legible-hover-color);
			}
		}
	}
}
:root[data-theme="light"] {
	nav {
		:deep() li.primary {
			background-color: var(--background-400);

			&.active {
				background-color: var(--ls-primary-legible-color);
			}

			&:hover {
				background-color: var(--ls-primary-legible-hover-color);
			}
		}
	}
}

@media (max-width: 480px) {
	:deep() li {
		width: 40px;
		height: 40px;

		svg {
			width: 22px;
			height: 22px;
		}

		span {
			font-size: 0.75rem;
			top: 36px;
		}

		&.active {
			span {
				top: 42px;
			}
		}

		&:hover {
			span {
				top: 42px;
			}
		}
	}
}

@media (max-width: 440x) {
	:deep() li {
		width: 38px;
		height: 38px;
		margin-top: 0.25rem;

		svg {
			width: 24px;
			height: 24px;
		}

		&.active {
			span {
				top: 40px;
			}
		}

		span {
			font-size: 1rem;
			top: 34px;
		}
		&:hover {
			span {
				top: 40px;
			}
		}
	}
}

@media (max-width: 440px) {
	:deep() li {
		margin-top: 1rem;
	}

	:deep() ul:has(> li:nth-child(5)) li span {
		display: none;
	}
}
</style>
